import { useCallback, useEffect } from 'react';
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ApplicationPermission from './ApplicationPermission';
import userManagementOperations from '../../../../../redux/UserManagement/operations'
import userManageSelectors from '../../../../../redux/UserManagement/selectors'
import { SetActiveAppArea, SetAddAppPermission, setAppPermissionById, setAppPermissionListing, SetCheckAppPermission, setDeleteAppPermission } from 'redux/UserManagement/action';
import { popupInitialData } from 'utils';
import ConfirmationBee from '../../../../assets/images/ConfirmationBee.svg'
import SuccessBee from '../../../../assets/images/SuccessBee.svg'
import { commonPopupDisplay } from '../../utils/AdministrationUtils';

const AppPermissionContainer = () => {
  const dispatch = useDispatch();
  const [isSubmit, setIsSubmit] = useState(false);
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const dispatchAddAppPermission = userManagementOperations.dispatchGetAddAppPermission(dispatch);
  const dispatchCheckAppPermission = userManagementOperations.dispatchGetCheckAppPermission(dispatch);
  let initialDetail = {
    id: 0,
    applicationID: 0,
    applicationName: "",
    name: "",
    description: "",
    appAreaId: 0,
    appAreaName: ""
  }
  const [detail, setDetail] = useState<any>(initialDetail)
  const initialValues = {
    nameVal: '',
    appArea: '',
    appName: '',
    permissionDesc: ''
  }
  const initialError = {
    nameValError: '',
    appAreaError: '',
    appNameError: '',
    permissionDescError: ''
  }
  const [form, setForm] = useState<any>(initialValues);
  const [formError, setFormError] = useState<any>(initialError);
  const [showAppPerPopup, setshowAppPerPopup] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const [applicationId, setApplicationId] = useState(0)
  const [appPerName, setAppPerName] = useState("")
  const [onChangeDropDown, setOnChangeDropDown] = useState<any>([])
  const [isAdding, setIsAdding] = useState(false);
  const dispatchAppPermissionListing = userManagementOperations.dispatchAppPermissionListing(dispatch);
  const dispatchAppPermissionById = userManagementOperations.dispatchAppPermissionById(dispatch)
  const dispatchDeleteAppPermission = userManagementOperations.dispatchDeleteAppPermission(dispatch)
  const dispatchGetActiveApplication = userManagementOperations.dispatchGetActiveApplication(dispatch)
  const dispatchGetActiveAppArea = userManagementOperations.dispatchGetActiveAppArea(dispatch)
  const {
    checkAppPermission,
    addAppPerVal,
    deleteAppPermission,
    appPermissionById,
    isCheck,
    isCheckAppPer
  }: any
    = useSelector(
      (state: any) => ({
        checkAppPermission: userManageSelectors.checkAppPermission(state),
        addAppPerVal: userManageSelectors.addAppPerVal(state),
        deleteAppPermission: userManageSelectors.deleteAppPermission(state),
        appPermissionById: userManageSelectors.appPermissionById(state),
        isCheck: state.UserManagement.isCheck,
        isCheckAppPer: userManageSelectors.isCheckAppPer(state),
      })
    )


  const [clickedId, setClickedId] = useState(0)
  useEffect(() => {
    dispatchGetActiveApplication()
    dispatch(setAppPermissionListing([]))
  }, [])

  const togglePopup = () => {
    setshowAppPerPopup((prev) => !prev);
    if (appPermissionById.hasOwnProperty("id")) {
      if (showAppPerPopup == true) {
        dispatch(setAppPermissionById([]))
        dispatch(setAppPermissionById(initialDetail))
        setFormError(initialError)
      }
    } else {
      if (showAppPerPopup == true) {
        setForm(initialValues);
        setFormError(initialError);
      }
    }
    dispatch(SetCheckAppPermission(true))
  };

  const handleApplicationChange = (_e?: any, item?: any) => {
    if (item != undefined) {
      dispatch(setAppPermissionListing([]))
      if (item?.key) {
        setApplicationId(item.key)
        dispatchGetActiveAppArea(item.key)
      } else {
        dispatch(SetActiveAppArea([]))
      }
    }
  }
  const handleAppAreachange = (evt?: any, item?: any) => {
    let val = {
      appId: applicationId,
      appAreaId: item.key
    }
    setOnChangeDropDown(val)
    if (item.key != null) {
      dispatchAppPermissionListing(val)
    }
  }

  const optionHandler = (evt: any, option: any, props: any) => {
    if (option.value === "editSecurityPermission") {
      togglePopup();
      dispatchAppPermissionById(props.id)
    }
    if (option.value === "deleteSecurityPermission") {
      setShowDeleteModal(true);
      setClickedId(props.id)
      setAppPerName(props.permissionName)
    }
  };
  const handleDeleteClick = () => {
    dispatchDeleteAppPermission(clickedId)
    setClickedId(0)

  }
  useEffect(() => {
    if (deleteAppPermission) {
      setShowDeleteModal(false);
      setShowInfoModal(true)
      dispatch(setDeleteAppPermission(false))
    }
  }, [deleteAppPermission])
  const handleInfoModal = () => {
    setShowInfoModal(false);
    setAppPerName("")
    dispatchAppPermissionListing(onChangeDropDown)
  }
  const handleDeleteModal = () => {
    setShowDeleteModal(false);
  };
  const handleClickPopup = () => {
    hideDialog()
    togglePopup()
    dispatch(setAppPermissionById([]))
    dispatch(setAppPermissionById(initialDetail))
    setFormError(initialError)
    if (onChangeDropDown?.length != 0) {
      dispatchAppPermissionListing(onChangeDropDown)
    }
    dispatch(SetAddAppPermission(0))
  }
  const handleFailurePopup = () => {
    hideDialog()
    dispatch(SetAddAppPermission(0))
  }
  const validation: any = (name: any, value: any) => {
    let error = { ...formError };
    switch (name) {
      case "nameVal":
        if (value === undefined || value === "" || value === null) {
          error.nameValError = "Please enter Name";
        } else {
          error.nameValError = "";
        }
        break;
      case "appArea":
        if (value.key === undefined || value.key === "" || value.key === null) {
          error.appAreaError = "Please select Application Area";
        } else {
          error.appAreaError = "";
        }
        break;
      case "appName":
        if (value.key === undefined || value.key === "" || value.key === null) {
          error.appNameError = "Please select Application Name";
        } else {
          error.appNameError = "";
        }
        break;
      case "permissionDesc":
        if (value === undefined || value === "" || value === null) {
          error.permissionDescError = "Please enter Permission Description";
        } else {
          error.permissionDescError = "";
        }
        break;

    }
    return error;
  }

  const handleChange = (e?: any, item?: any) => {
    let value = item;
    let name = e.target.getAttribute('name')
    setForm({ ...form, [name]: value });
    let formValidationError: any = {};
    let formValidation = validation(name, value);
    formValidationError[name + 'Error'] = formValidation[name + 'Error']
    setFormError({ ...formError, [name + 'Error']: formValidation[name + 'Error'] })
  }
  const handleClickSave = () => {
    setIsSubmit(true)
    let valid = true;
    let formValError: any = {};
    for (let key in form) {
      let formVal = validation(key, form[key]);
      formValError[key + 'Error'] = formVal[key + 'Error'];
      if (formVal[key + 'Error']) {
        valid = false;
      }
    }
    setFormError({ ...formValError })
    if (valid == true) {
      let filledVal = {
        id: appPermissionById?.hasOwnProperty("id") ? appPermissionById.id : 0,
        applicationID: form.appName.key,
        applicationName: appPermissionById?.hasOwnProperty("id") ? "" : form.appName.text,
        permissionName: form.nameVal,
        permissionDescription: form.permissionDesc,
        appAreaId: form.appArea.key,
        appAreaName: appPermissionById?.hasOwnProperty("id") ? " " : form.appArea.text
      }
      setDetail(filledVal)
    }
  }

  useEffect(() => {
    if (isSubmit && detail?.permissionName) {
      dispatchCheckAppPermission(detail)
    }
  }, [detail, isSubmit])

  useEffect(() => {
    if (!checkAppPermission && detail?.permissionName) {
      dispatchAddAppPermission(detail)
      setDetail([])
      setIsAdding(true)
    }
    else if (checkAppPermission && isSubmit) {
      let message = "Permission Name given is already exist."
      commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      setIsSubmit(false)
    }
  }, [checkAppPermission, isCheck])

  useEffect(() => {
    if (addAppPerVal != undefined && addAppPerVal != 0 && isSubmit) {
      if (addAppPerVal > 0 && !checkAppPermission) {
        var message: any = "";
        if((appPermissionById.hasOwnProperty("id") && appPermissionById.id != 0)){
          message = "Application Permission has been updated successfully.";
        }else{
          message = `Application Permission has been created successfully with id ` + addAppPerVal;
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, SuccessBee, "SUCCESS", handleClickPopup)
      } else if ((checkAppPermission && addAppPerVal == 0 && isCheckAppPer) || (addAppPerVal == "error")) {
        var message: any = "";
        if(addAppPerVal == "error"){
          message = "Error Occured while processing the request."
        }else{
          message = "Permission Name given is already exist."
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      }
      setIsSubmit(false)
      setIsAdding(false)
    }
  }, [addAppPerVal, isAdding])

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  return (
    <ApplicationPermission
      optionHandler={optionHandler}
      handleClickPopup={handleClickPopup}
      handleFailurePopup={handleFailurePopup}
      handleApplicationChange={handleApplicationChange}
      handleAppAreachange={handleAppAreachange}
      togglePopup={togglePopup}
      showAppPerPopup={showAppPerPopup}
      handleClickSave={handleClickSave}
      showDeleteModal={showDeleteModal}
      handleDeleteModal={handleDeleteModal}
      handleDeleteClick={handleDeleteClick}
      appPerName={appPerName}
      showInfoModal={showInfoModal}
      handleInfoModal={handleInfoModal}
      handleChange={handleChange}
      formError={formError}
      form={form}
      setForm={setForm}
      Popupcontent = {Popupcontent}
    />
  )
}

export default AppPermissionContainer;
